export default __webpack_public_path__ + "static/apple-touch-icon-152x152-0b2f4c752ae6626d4cbd9778660d2952.png";